import { z } from "zod";
import getTreezorAccountCreatorKycLiveness from "./getTreezorAccountCreatorKycLiveness.js";

export default {
  params: z.object({
    memberInvitationId: z.string(),
  }),
  response: getTreezorAccountCreatorKycLiveness.response,
};
